import React from 'react';
import {Field} from 'redux-form/immutable';
import {SelectField} from 'redux-form-antd'
import {
    required,
    nullValue1
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};
const SseRichState = props => {
    const ans = '經濟狀況'
    const select_arr = [
        {
            value: '-1',
            label: '請選擇'
        },
        {
            value: '1',
            label: '富裕'
        },
        {
            value: '2',
            label: '小康'
        },
        {
            value: '3',
            label: '清寒'
        },
        {
            value: '4',
            label: '貧困'
        }
    ]
    return (
        <div>
            <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label={ans}
                   options={select_arr} name="sse_rich_state" type="text"></Field>
        </div>
    )
}

export default SseRichState


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentForm/SseRichState.jsx